export const FETCHED_LABELS = 'FETCHED_LABELS';
export const FETCHED_LABEL = 'FETCHED_LABEL';
export const FETCH_LABEL_TYPES = 'FETCH_LABEL_TYPES';
export const CREATED_LABEL = 'CREATED_LABEL';
export const UPDATED_LABEL = 'UPDATED_LABEL';
export const DELETED_LABEL = 'DELETED_LABEL';
export const FETCHED_LABEL_TRANSLATIONS = 'FETCHED_LABEL_TRANSLATIONS';
export const FETCHED_LABEL_TRANSLATION = 'FETCHED_LABEL_TRANSLATION';
export const DELETED_LABEL_TRANSLATION = 'DELETED_LABEL_TRANSLATION';
export const EDIT_LABELS_TEXT_FIELD_INLINE = 'EDIT_LABELS_TEXT_FIELD_INLINE';
export const GET_LABEL_TRANSLATION_FOR_SITE = 'GET_LABEL_TRANSLATION_FOR_SITE';


// WEBPACK FOOTER //
// ./src/containers/labels/types.js